import * as React from 'react';

import { useSelector } from 'react-redux';
import { trackServiceBannerClickChange } from './tracking';
import { ServiceBanner } from '../../components/ServiceBanner';
import { getNewbuildingId } from '../../selectors/newbuilding';

export interface IServiceBannerContainerProps {
  type: 'builder' | 'seller';
  isMultiSeller?: boolean;
}

export const ServiceBannerContainer = ({ type, isMultiSeller }: IServiceBannerContainerProps) => {
  const newbuildingId = useSelector(getNewbuildingId);

  const onClick = React.useCallback(() => {
    trackServiceBannerClickChange(newbuildingId);
  }, [newbuildingId]);

  return <ServiceBanner type={type} onClick={onClick} isMultiSeller={isMultiSeller} />;
};
